import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-app-button',
    templateUrl: './app-button.component.html',
    styleUrls: ['./app-button.component.scss'],
})
export class AppButtonComponent {
    @Input()
    public isHallow = false;

    @Input()
    public isSolid = false;

    @Input()
    public icon: string;

    @Input()
    public disabled: string;

    private _click = new EventEmitter();

    @Output()
    public get clickEvent() {
        return this._click;
    }
    public set clickEvent(value) {
        this._click = value;
    }

    constructor() {}
    onClick($event) {
        this.clickEvent.emit($event);
    }
}
